import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { ComparisonSection } from './components/ComparisonSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-ochre/30" data-id="element-0" data-mp="3ij66mgga9xb1">
      <MetaPixel data-id="element-1" data-mp="3mjztr7lwj82v" />
      <AnnouncementBar data-id="element-2" data-mp="3mjg93j4va5l5" />
      <main data-id="element-3" data-mp="3rcj6y3gog175">
        <HeroSection data-id="element-4" data-mp="3rbrc4uuwm7hx" />
        <StatsBar data-id="element-5" data-mp="3rdkhm6ts6loc" />
        <TransformationSection data-id="element-6" data-mp="3rd1all5o5hp3" />
        <ComparisonSection data-id="element-7" data-mp="5yhupa6n3cr" />
        <PainPointsSection data-id="element-8" data-mp="6801qozk67w" />
        <KitContentsSection data-id="element-9" data-mp="5ghbgghm2z1" />
        <InstantAccessSection data-id="element-10" data-mp="7stte3h7l4p" />
        <BonusesSection data-id="element-11" data-mp="2zlv6ktmtuzuj" />
        <PricingSection data-id="element-12" data-mp="2zmemy5wtxg6g" />
        <GuaranteeSection data-id="element-13" data-mp="2zn6biws0edn8" />
        <TestimonialsSection data-id="element-14" data-mp="33mf2jtvnzxf3" />
        <FAQSection data-id="element-15" data-mp="33nq4do5juv3k" />
        <FinalCTASection data-id="element-16" data-mp="33n6wl09m5n39" />
      </main>
      <Footer data-id="element-17" data-mp="38lrrqla0dgku" />
    </div>;
}